export default "__VITE_ASSET__DaBJ4we8__"